import React from 'react';
import PropTypes from 'prop-types';
import { Link, Route } from 'react-router-dom';
import { map, sortBy } from 'lodash';
import Tab from 'fuse-ui/components/Tab';
import Tabs from 'fuse-ui/components/Tabs';
import { withStyles } from '@material-ui/core/styles';

import ReportContentContainer from '../containers/report-content-container';

const styles = theme => ( {
    activeTabIndicator: {
        width: 200,
    },
} );

const Reports = ( { handleTabChange, reportMap, reportTabIndex, match, classes } ) => {
    return (
        <React.Fragment>
            <Tabs
                onChange={handleTabChange}
                value={reportTabIndex}
                className="no-print"
            >
                {
                    map( sortBy( reportMap, ['index'] ), ( report ) => (
                        <Tab
                            label={report.label}
                            component={Link}
                            to={`${match.url}/${report.url}`}
                            key={report.index}
                            data-automation-id={`tab-${report.index}`}
                            className={classes.activeTabIndicator}
                        />
                    ) )
                }
            </Tabs>
            <Route path={`${match.url}/:reportId?`} component={ReportContentContainer} />
        </React.Fragment>
    );
};

Reports.propTypes = {
    classes: PropTypes.object,
    handleTabChange: PropTypes.func,
    match: PropTypes.shape( {
        url: PropTypes.string
    } ),
    reportMap: PropTypes.object.isRequired,
    reportTabIndex: PropTypes.any,
};

export default withStyles( styles )( Reports );
